
export const customErrors = {
    noItemHash: "Отсутствует хэш",
    noOrderId: "Отсутствует номер заказа",
    noUser: "Войдите или зарегистрируйтесь",
    noItemNumber: "Отсутствует номер девайса",
    deviceNotFound: "Товар не найден"
}